import request from '../utils/request';

export interface ICatalogProps {
  level: 1 | 2;
  parentId?: number | null;
}

export function listCatalogs(params: ICatalogProps) {
  return request.get('/api/catalog/get_catalogs', {
    params,
  });
}

export interface IProductProps {
  catalogId?: number | null;
  limit: number;
  page: number;
  queryKey?: string | null;
}

export function listProducts(params: IProductProps) {
  return request.get('/api/product/get_products', {
    params,
  });
}

export function getProductById(id: number) {
  return request.get(`/api/product/detail/${id}`);
}

export function getRelationProducts(id: number) {
  return request.get('/api/product/get_relation_products', {
    params: {
      id,
    },
  });
}
